import React from "react";
import { TiSocialInstagram } from "react-icons/ti";
import "./index.css";

const Logo = () => {
  return <TiSocialInstagram className="instagram-icon" />;
};

export default Logo;
